export abstract class ApiService {

}
